import { useTheme } from "@hooks";
import { constants } from "@layout";
import { CSSProperties } from "react";
import styled from "styled-components";

export const Container = styled.div<{ scrollable?: boolean; wide?: boolean }>`
  min-width: 320px;
  max-width: ${({ wide }) => (wide ? "600px" : "375px")};
  padding: ${constants.divPadding}px;
  ${({ scrollable }) =>
    scrollable &&
    `
    max-height: 70vh;
    margin: 20px auto;
    display: flex;
    flex-direction: column;
    
    @media (max-height: 600px) {
      max-height: 60vh;
      margin: 10px auto;
    }
    
    @media (max-height: 500px) {
      max-height: 50vh;
      margin: 5px auto;
    }
  `}

  ${({ wide }) =>
    wide &&
    `
    @media (min-width: 768px) {
      max-width: 700px;
    }
    
    @media (min-width: 1024px) {
      max-width: 800px;
    }
  `}
`;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    horizontal: {
      flexDirection: "row-reverse",
      display: "flex",
    },
    secondary: {
      backgroundColor: theme.modal.button.secondary,
    },
  };

  return styles;
};
